

//Use this for Azure Deployment
// export const ApiUriContants = {
//     fuel: 'master/api/Fuel/',
//     fuelGroup: 'master/api/FuelGroup/',
//     Operators: 'master/api/Operator/',
//     fuelCategory: 'master/api/FuelCategory/',
//     vessel: 'master/api/Vessel/',
//     vesselgroup: 'master/api/VesselGroup/',
//     policy: 'user/api/Policy/',
//     user: 'user/api/Users/',
//     role: 'user/api/Role/',
//     unitsOfMeasureAndThreshold: 'master/api/UnitOfMeasureThreshold/',
//     unitsOfMeasure: 'master/api/UnitOfMeasure/',
//     consumption: 'master/api/Consumptioncategory/',
//     event: 'master/api/Event/',
//     customvessel: 'master/api/CustomVesselField/',
//     getVesselType: 'master/api/Vessel/',
//     noxPmFactor: 'master/api/NOXPMFactor/',
//     engineCategory: 'master/api/ConsumptionCategory/',
//     term: 'master/api/Terms/',
//     vpterm: 'master/api/VPTerms/',
//     customFuelKpi: 'master/api/FuelKPI/',
//     customPositionKpi: 'master/api/PositionKPI/',
//     alertType: 'master/api/AlertSettings/',
//     vesselClass: 'master/api/VesselClass/',
//     vesselOwner: 'master/api/VesselOwner/',
//     vesselPoolType: 'master/api/VesselPoolType/',
//     account: 'user/api/Account/',
//     voyages: 'voyage/api/Voyages/',
//     Ems: 'voyage/api/Ems/',
//     mrv: 'voyage/api/MRV/',
//     TrackingScreen: 'voyage/api/FleetView/',
//     AER: 'voyage/api/AER/',
//     Annual: 'voyage/api/AnnualVessel/',
//     port: 'master/api/Port/',
//     alertSetting: 'master/api/AlertSettings/',
//     reports: 'report/api/',
//     about: 'master/api/About/',
//     analytics: 'master/api/Analytics/',
//     reportService: 'Report/',
//     ScheduledReport: 'master/api/ScheduledReport/',
//     lubeOil: 'master/api/LubeOil/',
//     principal: 'master/api/Principal/',
//     dataVerifier: 'master/api/DataVerifier/',
//     seaTrial: 'master/api/SeaTrial/',
//     meShopTest: 'master/api/MeShopTest/',
//     aeShopTest: 'master/api/AeShopTest/',
//     aeElectricalLoad: 'master/api/AeElectricalLoad/',
//     verificationService: 'api/app/data-verification-inbound/',
//     operator: 'master/api/Operator/',
//     emissionBackground: 'api/EmissionBackground/',
//     iceClassType: 'master/api/IceClassType/',
//     cargoPumpType: 'master/api/CargoPumpType/',
//     sensormaster: 'api/SensorMaster/',
//     sensormapping: 'api/VesselSensorMap/',
//     sensorgrouping: 'api/SensorEnrichModule/',
//     FuelEu: 'voyage/api/FuelEU/',
//     cpBackGround:'api/LNGTC',
//     tcTerms: 'master/api/TcTerms/',
//     timeCharterer: 'master/api/TimeCharterer/',
// };


//Use this for IIS Deployment
export const ApiUriContants = {
    dtVesselModel: 'api/master/DTVesselModel/',
    dtDegradingFactor: 'api/master/DTDegradingFactor/',
    dtReport: 'api/digital-twin/PredictedPower/',
    Kpler: 'api/master/Kpler/',
    KplerJob: 'api/stratum-jobs/Jobs/',
    fuel: 'api/master/Fuel/',
    fuelGroup: 'api/master/FuelGroup/',
    Operators: 'api/master/Operator/',
    fuelCategory: 'api/master/FuelCategory/',
    vessel: 'api/master/Vessel/',
    vesselgroup: 'api/master/VesselGroup/',
    policy: 'api/user/Policy/',
    user: 'api/user/Users/',
    role: 'api/user/Role/',
    unitsOfMeasureAndThreshold: 'api/master/UnitOfMeasureThreshold/',
    unitsOfMeasure: 'api/master/UnitOfMeasure/',
    consumption: 'api/master/ConsumptionCategory/',
    event: 'api/master/Event/',
    customvessel: 'api/master/CustomVesselField/',
    getVesselType: 'api/master/Vessel/',
    noxPmFactor: 'api/master/NOXPMFactor/',
    engineCategory: 'api/master/ConsumptionCategory/',
    term: 'api/master/Terms/',
    vpterm: 'api/master/VPTerms/',
    customFuelKpi: 'api/master/FuelKPI/',
    customPositionKpi: 'api/master/PositionKPI/',
    alertType: 'api/master/AlertSettings/',
    vesselClass: 'api/master/VesselClass/',
    vesselOwner: 'api/master/VesselOwner/',
    vesselPoolType: 'api/master/VesselPoolType/',
    account: 'api/user/Account/',
    voyages: 'api/voyage/Voyages/',
    Ems: 'api/voyage/Ems/',
    mrv: 'api/voyage/MRV/',
    TrackingScreen: 'api/voyage/FleetView/',
    AER: 'api/voyage/AER/',
    Annual: 'api/voyage/AnnualVessel/',
    port: 'api/master/Port/',
    alertSetting: 'api/master/AlertSettings/',
    Reports: 'api/reports/',
    about: 'api/master/About/',
    analytics: 'api/master/Analytics/',
    reportService: 'api/report-engine/Report/',
    ScheduledReport: 'api/master/ScheduledReport/',
    lubeOil: 'api/master/LubeOil/',
    principal: 'api/master/Principal/',
    dataVerifier: 'api/master/DataVerifier/',
    dataVerifierCompany: 'api/master/VerifierCompany/',
    seaTrial: 'api/master/SeaTrial/',
    meShopTest: 'api/master/MeShopTest/',
    aeShopTest: 'api/master/AeShopTest/',
    aeElectricalLoad: 'api/master/AeElectricalLoad/',
    verificationService: 'api/data-verification/data-verification-inbound/',
    operator: 'api/master/Operator/',
    emissionBackground: 'api/emission-jobs/EmissionBackground/',
    iceClassType: 'api/master/IceClassType/',
    cargoPumpType: 'api/master/CargoPumpType/',
    sensormaster: 'api/sensor-engine/SensorMaster/',
    sensormapping: 'api/sensor-engine/VesselSensorMap/',
    sensorgrouping: 'api/sensor-engine/SensorEnrichModule/',
    FuelEu: 'api/voyage/FuelEU/',
    cpBackGround: 'api/lng-job/LNGTC',
    tcTerms: 'api/master/TcTerms/',
    timeCharterer: 'api/master/TimeCharterer/',
    maptile: 'api/voyage/MapTile/',
    weatherTile: 'api/voyage/WeatherTile/',
    cpBackGroundTcV2: 'api/lng-job/TCV2',
    commericalRate: 'api/master/Commercial/',
    useroperator: 'api/voyage/UserOperator/',
    dtseatrail: 'api/digital-twin/SeaTrialMatrix/',
    meShopTestMatrix: 'api/digital-twin/MeShopTestMatrix/',
    TrackingScreenMapTiler: 'api/voyage/TrackScreen/',
    cpBackGroundTcV2LNG: 'api/lng-job/TCV2LNG',
    verificationdownload: 'api/data-verification/verifavia-data-processing/',
    currenices: 'api/master/Currency/',
    uwService: 'api/digital-twin/UwServices/',
    vesonROE: 'api/voyage/api/VesonROE/',
    dtHCR: 'api/digital-twin/HCR/',

    
};
